export default "__VITE_ASSET__5bcee6c9__"